import { Toaster } from 'sonner';
import { NotiIcon } from '@anytag/shared-atoms';

export const NotificationProvider = () => (
  <Toaster
    duration={5000}
    icons={{
      success: <NotiIcon icon="check" variant="green" size="14px" />,
      error: <NotiIcon icon="error" variant="red" />,
      info: <NotiIcon icon="info" variant="blue" />,
      warning: <NotiIcon icon="warning" variant="yellow" />
    }}
    toastOptions={{
      style: {
        borderRadius: '3px',
        padding: '12px'
      }
    }}
  />
);
